const certificateApp = Vue.createApp({
    data() {
        return {
            certifications: certifications,
            certificationPage: 1,
            certificationPerPage: 6,
            certificationPages: [],
            totalNumberofCertificationPages: 0,
            deliveryChannels: [],
            selectedDelivery: [],
            topics: [],
            selectedTopic: ""
        }
    },
    methods: {

        setCertificationPages(certifications) {
            this.certificationPages = [];
            this.totalNumberofCertificationPages = Math.ceil(certifications.length / this.certificationPerPage);
            this.certificationPages = pagination(this.certificationPage, this.totalNumberofCertificationPages);
        },

        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },

        resetPages() {
            this.certificationPage = 1;
        },

        onTopicChange() {
            this.resetPages();
        },

        onDeliveryChange() {
            this.resetPages();
        },
        getWidget(certification) {
            var result = "";

            if (certification.BagPart != ""
                && certification.BagPart.ContentItems != ""
                && certification.BagPart.ContentItems[0].FlowPart != ""
                && certification.BagPart.ContentItems[0].FlowPart.Widgets != "") {

                var widgets = certification.BagPart.ContentItems[0].FlowPart.Widgets;
                widgets.forEach(checkWidgets);

                function checkWidgets(widget) {
                    if (widget.ContentType == "ImageHeaderBody") {
                        result = widget.ImageHeaderBody.Body.Html.replace(/<\/?[^>]+(>|$)/g, "");
                    }
                }
            }

            return result;
        },
        getImageMediaText(cmsImage) {
            return getOrchardImageMediaText(cmsImage);
        }
    },
    computed: {
        displayedCertifications() {
            var filteredCertifications = this.certifications.filter(function (item) {
                return ((item.CertificationPage.Taxonomy.TagNames.includes(this.selectedTopic) || this.selectedTopic == "") && (this.selectedDelivery.some(i => item.CertificationPage.DeliveryType.Values.includes(i)) || this.selectedDelivery == ""))
            }, this);
            this.setCertificationPages(filteredCertifications);
            return this.paginate(filteredCertifications, this.certificationPage, this.certificationPerPage);
        }
    },
    watch: {
        certificationPage: function (val) {
            scrollOnPagination("pgn-certifications");
        }
    },
    created() {
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + '...';
        }
    }
});

const certificateMountedApp = certificateApp.mount('#certifications');

document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((t, i) => {
    t.addEventListener('show.bs.tab', function (event) {
        var targetClass = event.target.dataset["bsTarget"];
        var panes = document.querySelectorAll(targetClass);
        var siblings = document.querySelectorAll('#product-tab-content .tab-pane.active');

        siblings.forEach(function (sibling) {
            sibling.classList.remove('show');
            sibling.classList.remove('active');
        });

        panes.forEach(function (pane) {
            pane.classList.add('show');
            pane.classList.add('active');
        });
    })
})